module.exports = __webpack_public_path__ + "static/media/About-Us_tb.289475f0.jpg";